/**
 * setLocale — change the active UI language at runtime.
 *
 * Works in both development and production. In production the locale bundle
 * is lazy-loaded on first use. The choice is persisted in localStorage so it
 * survives page reloads.
 *
 * Browser console usage:
 *   __eg.setLocale('uk')   // switch to Ukrainian
 *   __eg.setLocale('en')   // switch back to English
 *   __eg.locale            // read current locale
 *   __eg.locales           // list supported locales
 */

import i18n, { supportedLanguages } from "./i18n";
import { loadProductionLocale } from "./loadProductionLocale";

const LOCALE_STORAGE_KEY = "eg_locale";

export async function setLocale(lang) {
  if (!supportedLanguages.includes(lang)) {
    console.warn(
      `[i18n] Unsupported locale "${lang}". Supported: ${supportedLanguages.join(
        ", "
      )}`
    );
    return;
  }

  if (process.env.NODE_ENV === "production") {
    await loadProductionLocale(lang);
  } else {
    i18n.locale = lang;
    document.documentElement.lang = lang;
  }

  localStorage.setItem(LOCALE_STORAGE_KEY, lang);
  console.info(`[i18n] Locale switched to "${lang}"`);
}
